import NumberFlow from '@number-flow/react';
import { Minus, Plus } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'src/components/ui/button';
import { Card } from 'src/components/ui/card';
import { Slider } from 'src/components/ui/slider';

export function ForecastPaginatedControlsSkeleton() {
  const { t } = useTranslation('forecast');

  return (
    <Card className='mt-4 flex h-44 w-full flex-col gap-y-4 p-4 lg:mt-0 lg:w-1/3'>
      <div className='flex flex-col gap-y-2'>
        <div className='flex flex-row items-center gap-x-2 text-sm opacity-50'>
          <span>{t('Height')}</span>
          <NumberFlow className='text-layout-foreground-secondary' value={5} />
        </div>
        <div className='flex flex-row items-center gap-x-2'>
          <Button variant='outline' size='icon' className='px-2' disabled>
            <Minus className='h-4 w-4' strokeWidth={2} />
          </Button>
          <Slider
            value={[5]}
            onValueChange={() => {}}
            min={1}
            max={10}
            step={1}
            className='w-full opacity-50'
            disabled
          />
          <Button variant='outline' size='icon' className='px-2' disabled>
            <Plus className='h-4 w-4' strokeWidth={2} />
          </Button>
        </div>
      </div>
      <div className='flex flex-col gap-y-2'>
        <div className='flex flex-row items-center gap-x-2 text-sm opacity-50'>
          <span>{t('Trend')}</span>
          <NumberFlow className='text-layout-foreground-secondary' value={5} />
        </div>
        <div className='flex flex-row items-center gap-x-2'>
          <Button variant='outline' size='icon' className='px-2' disabled>
            <Minus className='h-4 w-4' strokeWidth={2} />
          </Button>
          <Slider
            value={[5]}
            onValueChange={() => {}}
            min={1}
            max={10}
            step={1}
            className='w-full opacity-50'
            disabled
          />
          <Button variant='outline' size='icon' className='px-2' disabled>
            <Plus className='h-4 w-4' strokeWidth={2} />
          </Button>
        </div>
      </div>
    </Card>
  );
}
